import { render } from "./pdf-viewer.vue?vue&type=template&id=0d167ef6&scoped=true&ts=true"
import script from "./pdf-viewer.vue?vue&type=script&lang=ts"
export * from "./pdf-viewer.vue?vue&type=script&lang=ts"

import "./pdf-viewer.vue?vue&type=style&index=0&id=0d167ef6&lang=css"
import "./pdf-viewer.vue?vue&type=style&index=1&id=0d167ef6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\blanger\\Development\\testing\\vue-pdf-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d167ef6"]])

export default __exports__